import { AuthProvider, useAuth } from './auth/AuthContext'
import { CompanyProvider } from './auth/CompanyContext'
import { YearProvider } from './auth/YearContext'
import { Login } from './pages/Login'
import { Dashboard } from './pages/Dashboard'
import { isAllowed } from './firebase'
import { ErrorBoundary } from './components/ErrorBoundary'

function Gate() {
  const { user, loading } = useAuth()

  if (loading) {
    return <div className="center-msg">Laddar…</div>
  }

  if (!user || !isAllowed(user)) {
    return <Login />
  }

  return (
    <CompanyProvider>
      <YearProvider>
        <ErrorBoundary>
          <Dashboard />
        </ErrorBoundary>
      </YearProvider>
    </CompanyProvider>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <Gate />
      </ErrorBoundary>
    </AuthProvider>
  )
}
